import { Div } from "@tblabs/truffle";
import { Container } from "../../../Pages/Components/Container";
import { FaqItem } from "./FaqItem";
import { H2 } from "../../../Pages/Components/H2";
import { Section } from "../../../Pages/Components/Section";
import { ShopContentProvider } from "../../../Services/Content/ShopContentProvider";


export class FaqSection extends Container
{
    constructor(_shop: ShopContentProvider)
    {
        super(
            new Section("faq").Append(
                new H2("Często zadawane pytania").Class("section-title"),
                new Div("faq__list").Append(
                    ..._shop.Shop.AboutUsFaq.Items.map(x => new FaqItem(x.Question.value, x.Answer.value))
                )
            )
        );
    }
}
